<div class="text_black border_wrapper h-100 powertrain_wrapper summaryBox">
  <div
    class="p-4 d-flex align-items-center justify-content-between text-black h_20"
    style="border-top-left-radius: 6px; border-top-right-radius: 6px"
  >
    <h4 class="font-weight-bolder powertrain_headers">
      <span>Year-to-Date Savings</span>
      <span
        style="cursor: pointer"
        class="material-icons info"
        ngbPopover="
    This is the total amount that has been saved as compared to the last year as a result of reduced failures. Total cost of failure = Cost of failure/hr * Total duration of failure. The savings will be calculated from the second year of commissioning of powertrain
  "
        popoverClass="custom_popover"
        triggers="mouseenter:mouseleave"
        >info</span
      >
    </h4>
    <button mat-raised-button color="primary" (click)="openYTDBox()">
      Update
    </button>
  </div>
  <div class="d-flex h_80" style="justify-content: space-around">
    <div class="mt-2 ml-4 flex flex_70 gap_10">
      <div class="column_response_text_left w-100 h_20">
        YTD Unexpected Failures*
      </div>
      <div class="column_response_text_left w-100 h_20">
        YTD Total Failure Cost*
      </div>
      <div class="column_response_text_left w-100 h_20">
        Savings vs. Previous Year*
      </div>
    </div>
    <div class="mt-2 mr-4 flex flex_30 gap_10" *ngIf="!ytdMetricsLoader">
      <div class="column_response_text_right h_20 text-center w-100">
        {{ ytdMetricsV2.failures_count }}
      </div>
      <div class="column_response_text_right h_20 text-center w-100">
        {{ ytdMetricsV2.total_cost }}
      </div>
      <div class="column_response_text_right h_20 text-center w-100">
        {{ ytdMetricsV2.total_savings }}
      </div>
    </div>
    <div class="mt-2 mr-4 flex flex_30 gap_10" *ngIf="ytdMetricsLoader">
      <div class="skeleton skeleton-text w-100"></div>
      <div class="skeleton skeleton-text w-100"></div>
      <div class="skeleton skeleton-text w-100"></div>
    </div>
  </div>
</div>

<app-powertrain-modal
  [type]="'ytdMetrics'"
  [data]="ytdMetrics"
  *ngIf="showModal"
  (closeBox)="closeBox($event)"
></app-powertrain-modal>

<app-powertrain-modal
  [type]="'ytdMetricsV2'"
  [data]="{ subsystem_id: subsystemId }"
  *ngIf="showYTDModal"
  (closeYTDBox)="closeYTDBox($event)"
></app-powertrain-modal>
